import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedirectService } from 'src/app/service-components/salesorders/blind-salesorder/redirect.service';
import { OrderHistoryService } from './order-history.service';

@Component({
  selector: 'app-blind-cancellation-update',
  templateUrl: './blind-cancellation-update.component.html',
  styleUrls: ['./blind-cancellation-update.component.scss'],
})
export class BlindCancellationComponent implements OnInit, OnDestroy {
  goodParameters: boolean = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private orderHistoryService: OrderHistoryService,
    private redirectService: RedirectService
  ) {}

  ngOnInit(): void {
    document.body.classList.add('bare-page');

    this.processCancellation();
  }

  returnToFreshdesk(): void {
    this.redirectService.back();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('bare-page');
  }

  private processCancellation(): void {
    const customerNumber = this.route.snapshot.paramMap.get('customerNumber') ?? '';
    const orderNumber = this.route.snapshot.paramMap.get('orderNumber') ?? '';
    const orderPosNumber = this.route.snapshot.paramMap.get('orderPosNumber') ?? '';
    if (customerNumber === '' || orderNumber === '' || orderPosNumber === '') {
      console.error('Not enough parameters found.');
      return;
    }
    this.goodParameters = true;

    this.orderHistoryService.rejectCancellation(customerNumber, orderNumber, orderPosNumber).subscribe({
      next: () => {
        this.returnToFreshdesk();
      },
      error: (error: Error) => {
        this.error = 'Er ging iets mis met de aanpassing van de annulering.';
        console.error(error);
      },
    });
  }
}
